module.exports = __webpack_public_path__ + "img/icon-cont-4-.4c4b3d0e.png";